import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import * as complianceActions from '../actions/static-data-compliance.actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataPepRisksFeatureKey = 'staticDataPepRisks';

export interface StaticDataPepRisksState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: StaticDataPepRisksState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(complianceActions.loadPepRisks, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.loadPepRisksSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(complianceActions.loadPepRisksFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getPepRisks = (state: StaticDataPepRisksState) => state.data;
export const getPepRisksLoading = (state: StaticDataPepRisksState) => state.loading;
export const getPepRisksError = (state: StaticDataPepRisksState) => state.error;